import React, { useMemo, useState } from "react";
import { IExtractesDataModel } from "../../models/ChatModels";
import moment from "moment";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { ComplianceWorkflows, ComplianceRoles, ComplianceTags } from "../../models/ExtractedDataModels";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { text_convert_lower } from "../../helpers/GenericHelpers";
import SearchableDropdown from "../../commonfields/SearchableDropdown";
import { IDropdownOptionsModel } from "../../models/CommonFields";

interface IExtractedSettingsFormProps {
  selectedData: IExtractesDataModel | null;
  setSelectedData: React.Dispatch<
    React.SetStateAction<IExtractesDataModel | null>
  >;
  handleClear: Function;
  handleSubmit: Function;
}

const ExtractedSettingsForm = (props: IExtractedSettingsFormProps) => {
  const { selectedData, setSelectedData, handleClear, handleSubmit } = props;

  // states
  const [tags, setTags] = useState<string[]>(selectedData?.flags?.length > 0 ? Array.from(new Set([...selectedData?.flags, ...Object?.keys(ComplianceTags)])) :  Object?.keys(ComplianceTags));
  const [tagText, setTagText] = useState('');

  // helpers
  const isDate = useMemo(
    () => moment(selectedData?.value)?.isValid(),
    [selectedData]
  );

  const handleRolesChange = (values: IDropdownOptionsModel) => {
    setSelectedData(prev => {
      if (prev) return ({ ...prev , roles: values }) 
      else return prev
    })
  }

  const handleWorkflowChange = (values: IDropdownOptionsModel) => {
    setSelectedData(prev => {
      if (prev) return ({ ...prev , workflows: values }) 
      else return prev
    })
  }

  const addTag = () => {
    setTags(prev => ([ ...prev, tagText ]))
    setTagText('')
  }

  const handleTagChange = (value: string) => {
    const contains = selectedData?.flags?.includes(value)
    if (contains) {
      setSelectedData(prev => {
        if (prev) return { ...prev, flags: prev?.flags?.filter((each: any) => each !== value) }
        else return prev
      })
    }
    else setSelectedData(prev => {
      if (prev) return { ...prev, flags: [...prev?.flags, value] }
      else return prev
    })
  }

  // display functions
  const displayComplianceTags = () => {
    return tags?.map(each => 
      <FormGroup check inline>
        <Input checked={selectedData?.flags?.includes(each)} type="checkbox" onChange={() => handleTagChange(each)} />
        <Label check={selectedData?.flags?.includes(each)}>{each}</Label>
      </FormGroup>
    )
  }

  const displayOptions = (values: any) => {
    const keys = Object.keys(values)
    return keys?.map(each => ({
      value: text_convert_lower(each),
      label: text_convert_lower(each),
    }))
  }

  const handleMonitor = () => setSelectedData(prev => {
    if (prev) {
      return ({ 
        ...prev, 
        monitor: !prev?.monitor,
        ...(prev?.monitor ? { workflows: [] } : {})
      })
    } else return prev
  })

  // const displayForm = () => {
  //   if (isDate) {
  //     return (
  //       <div className="input-row">
  //         <FormGroup>
  //           <Label className="label" check={selectedData?.monitor}>Monitor</Label>
  //           <Input className="monitor-check" checked={selectedData?.monitor} type="checkbox" onChange={handleMonitor} />
  //         </FormGroup>
          
  //         <div className="worflow-selection">
  //           <div className="label">Workflows</div>
  //           <div className="dropdown">
  //             <SearchableDropdown
  //               value={selectedData?.workflows}
  //               handleChange={handleWorkflowChange}
  //               options={displayOptions(ComplianceWorkflows)}
  //               classNamePrefix='extractedSearch'
  //               isMulti={true}
  //               disabled={!selectedData?.monitor}
  //               placeholder='select workflow'
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div className="input-row">
  //         <div className="label">Roles</div>
  //         <div className="dropdown">
  //           <SearchableDropdown
  //             value={selectedData?.roles}
  //             handleChange={handleRolesChange}
  //             options={displayOptions(ComplianceRoles)}
  //             classNamePrefix='extractedSearch'
  //             isMulti={true}
  //             placeholder='select roles'
  //           />
  //         </div>
  //       </div>
  //     );
  //   }
  // };

  return (
    <div>
    <div className="form-box">
      <div className="form-left">
        <div className="input-checkbox">
          <div className="checkbox-label">Select Tags</div>
          <div className="check-tags-list">
            {displayComplianceTags()}
          </div>
        </div>
        <div className="input-row">
          <Button 
            className="add-tag" 
            disabled={tagText?.trim()?.length < 1}
            onClick={addTag}
          >
            <FontAwesomeIcon icon={faPlus} /> Add New Tag
          </Button>
          <Input
            id="tag"
            name="tag"
            type="text"
            value={tagText}
            onChange={e => setTagText(e?.target?.value)}
            placeholder="Please enter the tag"
          />
        </div>
      </div>
      <div className="divider"></div>
      <div className="form-right">
        {/* {displayForm()} */}
        <div className="input-row">
          <div className="label">Roles</div>
          <div className="dropdown">
            <SearchableDropdown
              value={selectedData?.roles}
              handleChange={handleRolesChange}
              options={displayOptions(ComplianceRoles)}
              classNamePrefix='extractedSearch'
              isMulti={true}
              placeholder='select roles'
            />
          </div>
        </div>
        <div className="input-row">
          <FormGroup>
            <Label className="label" check={selectedData?.monitor}>Monitor</Label>
            <Input className="monitor-check" checked={selectedData?.monitor} type="checkbox" onChange={handleMonitor} />
          </FormGroup>
          
          <div className="worflow-selection">
            <div className="label">Workflows</div>
            <div className="dropdown">
              <SearchableDropdown
                value={selectedData?.workflows}
                handleChange={handleWorkflowChange}
                options={displayOptions(ComplianceWorkflows)}
                classNamePrefix='extractedSearch'
                isMulti={true}
                disabled={!selectedData?.monitor}
                placeholder='select workflow'
              />
            </div>
          </div>
        </div>
      </div>
    </div>

      <div className="btns">
        <Button className="cancel" onClick={() => handleClear()}>
          Cancel
        </Button>
        <Button className="submit" onClick={() => handleSubmit()}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default ExtractedSettingsForm;
